<div class="fallback-report component">
  <div *ngIf="!isShowMore">
    <app-outages-notice></app-outages-notice>

    <div class="fallback-table wrapper">
      <div class="d-none d-md-block">
        <app-fallback-table-nav></app-fallback-table-nav>
      </div>
      <app-fallback-table [endpoint]="endpoint"></app-fallback-table>
    </div>
  </div>

  <app-more-info *ngIf="isShowMore"></app-more-info>
</div>